module.exports = __webpack_public_path__ + "static/media/step-photo-inactive.3acca58f.svg";